import { getFetchMethods } from '@cvg/react-hooks'
import auth from '@services/auth'
import logger from '@utils/logger'

// TODO update values
const apiKey = import.meta.env.PUBLIC_CONTENT_RESERVOIR_API_KEY
const baseUri = import.meta.env.PUBLIC_CONTENT_RESERVOIR_BASE_URI

export const { get, patch, post, put } = getFetchMethods({ apiKey, auth, baseUri, logger })
